export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export function Label({ className = "", children, ...props }: LabelProps) {
  return (
    <label
      className={`block text-xs font-medium text-text-soft mb-1.5 ${className}`}
      {...props}
    >
      {children}
    </label>
  );
}
